import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconUsdUpgrade = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={27}
    height={26}
    fill="none"
    viewBox="0 0 27 26"
    aria-hidden="true"
    {...props}
  >
    <g filter="url(#icon-usd-upgrade_svg__a)">
      <path
        fill="#fff"
        fillOpacity={0.95}
        d="M17.938 15.219c-.282 1.531-1.594 2.531-3.438 2.75V19c0 .563-.469 1-1 1-.563 0-1-.438-1-1v-1.063c-.031-.03-.031 0-.063-.03-.812-.095-1.656-.407-2.437-.657l-.344-.125c-.5-.188-.781-.75-.625-1.25a1 1 0 0 1 1.281-.625l.344.094c.688.25 1.438.5 2.063.594 1.5.218 3.062-.032 3.25-1.063.156-.906-.375-1.25-2.75-1.906l-.469-.125c-1.375-.375-4.219-1.188-3.719-4.063.281-1.5 1.594-2.5 3.469-2.719V5c0-.531.438-1 1-1 .531 0 1 .469 1 1v1.094c0 .031 0 0 .031.031.531.063 1.125.219 1.906.469.5.187.782.75.625 1.281-.187.5-.75.781-1.25.625a9.912 9.912 0 0 0-1.593-.406c-1.438-.219-3.031.031-3.219 1.062-.125.75.156 1.156 2.281 1.75l.469.156c1.875.5 4.688 1.282 4.188 4.157Z"
      />
    </g>
    <defs>
      <filter
        id="icon-usd-upgrade_svg__a"
        width={32}
        height={32}
        x={-2.5}
        y={-2}
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6025_5338"
        />
        <feColorMatrix
          in="SourceAlpha"
          result="hardAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feMorphology
          in="SourceAlpha"
          operator="dilate"
          radius={2}
          result="effect2_dropShadow_6025_5338"
        />
        <feOffset dy={2} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend
          in2="effect1_dropShadow_6025_5338"
          result="effect2_dropShadow_6025_5338"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect2_dropShadow_6025_5338"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
));
export default SvgIconUsdUpgrade;
